import api from 'lib/trpcClient';
import PreviousResultsContainer from './PreviousResultsContainer';
import { Row } from 'further-ui/components/Layout';
import { Box, styled, Typography } from '@mui/material';
import PreviousKybDetails from './PreviousKybDetails';
import PreviousKycDetails from './PreviousKycDetails';

const Container = styled(Box)(({ theme }) => ({
  padding: theme.spacing(0, theme.spacingSizes.sm),
}));

const ExpiredAt = styled(Typography)({
  flexShrink: 0,
});

type Props = {
  vehicleId: string;
  vehicleApplicationId: string;
};

const PreviousKycOrKybDetails: React.FC<Props> = ({
  vehicleId,
  vehicleApplicationId,
}) => {
  const [expiredKycDetails] = api.lpKyc.listExpiredKycDetails.useSuspenseQuery({
    vehicleId,
    vehicleApplicationId,
  });

  const [expiredKybDetails] = api.lpKyc.listExpiredKybDetails.useSuspenseQuery({
    vehicleId,
    vehicleApplicationId,
  });

  if (!expiredKycDetails.length && !expiredKybDetails.length) {
    return null;
  }

  return (
    <PreviousResultsContainer>
      {expiredKycDetails.map((kycDetails) => (
        <Container key={kycDetails.id}>
          <Row fullWidth justify="space-between">
            <PreviousKycDetails kycDetails={kycDetails} />
            <ExpiredAt variant="body2" align="right">
              Expired on {kycDetails.expiredAt?.toReadableWithTime()}
            </ExpiredAt>
          </Row>
        </Container>
      ))}
      {expiredKybDetails.map((kybDetails) => (
        <Container key={kybDetails.id}>
          <Row fullWidth justify="space-between">
            <PreviousKybDetails kybDetails={kybDetails} />
            <ExpiredAt variant="body2" align="right">
              Expired on {kybDetails.expiredAt?.toReadableWithTime()}
            </ExpiredAt>
          </Row>
        </Container>
      ))}
    </PreviousResultsContainer>
  );
};

export default PreviousKycOrKybDetails;
